import Vue from 'vue'
import Vuex from 'vuex' 

import app from './modules/app';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
		//
	},
	mutations: {
		//
	},
	actions: {

	},
	modules: {
		app
	}
});




// WEBPACK FOOTER //
// ./src/store/store.js